










import { Toast } from 'vant';
import { Vue, Component } from 'vue-property-decorator';
import { getRule } from '../api';

Vue.use(Toast);

@Component
export default class Rules extends Vue {
  content: any = '';
  mounted() {
    getRule().then((res: any) => {
      console.log('res::', res);
      if (res.code === 200) {
        this.content = res.data;
      } else {
        Toast(res.msg);
      }
    });
  }
}
